// extracted by mini-css-extract-plugin
export default {"genericCard":"Xo-z","inline":"Yo-z","mastercard":"Zo-z","discover":"_o-z","visa":"ap-z","amex":"bp-z","active":"cp-z"};